let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("leyxL")).then(() => parcelRequire('d9nVP'));